import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { ReactDefaultProps } from "@/types/react";

import styles from "./Modal.scss";

export type ModalSectionBaseProps = {
  customClass?: string;
};
export type ModalSectionProps = ModalSectionBaseProps &
  React.ComponentPropsWithoutRef<"div">;

const defaultProps = {
  customClass: undefined,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  ModalSectionBaseProps,
  typeof defaultProps
> = defaultProps;

export const ModalSection = ({
  children,
  customClass,
  ...others
}: ModalSectionProps): JSX.Element => (
  <div className={cx(styles.section, customClass)} {...others}>
    {children}
  </div>
);

ModalSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClass: PropTypes.string,
};

ModalSection.defaultProps = validatedDefaultProps;

ModalSection.displayName = "Modal.Section";

export default ModalSection;
